<div class="flex flex-2 flex-col overflow-x-hidden overflow-y-auto bg-white print:block print:w-full">
    <div class="flex h-full items-center justify-center overflow-x-hidden overflow-y-auto">
        <div class="w-[40rem] text-center">
            <h1 class="text-44">{{ presentation().title }}</h1>
            <p class="text-24">{{ presentation().message }}</p>
            <div class="flex justify-center gap-8 py-16">
                <button vds-button appearance="primary" (click)="retryLogin()">{{ presentation().primaryActionLabel }}</button>
                <button vds-button appearance="ghost" (click)="logout()">Log out</button>
            </div>
        </div>
    </div>
</div>
